export const classes = {
  tab: 'p-4 h-full',
  card: 'py-4 px-0 h-full',
  list: 'w-full min-h-0 max-h-[400px] overflow-auto py-0 pr-2 pb-4',
};
